module.exports = __webpack_public_path__ + "static/rs_logo_original-855a7f1cede3a936622fc609bca2837e.svg";